import { URL_API } from '../../../../services/api_url'
import { useAxiosHttpClient } from '../../../../hooks/useAxiosHttpClient'
import { RemoteGetContracts } from '../../../../data/usecases/Contracts/RemoteGetContracts'
import { useLocation } from 'react-router-dom'
import { RemoteGetContract } from '../../../../data/usecases/Contracts/RemoteGetContract'
import { ContractDetails } from '../../../../pages/Contracts/ContractDetails'
import { RemoteResendSignatureEmail } from '../../../../data/usecases/ContractSignatures/RemoteResendSignatureEmail'
import { RemoteCancelContract } from '../../../../data/usecases/Contracts/RemoteCancelContract'

export const ContractDetailsFactory = () => {
  const URL = URL_API || 'without-url'

  const axiosHttpClient = useAxiosHttpClient()
  const remoteGetContract = new RemoteGetContract(URL, axiosHttpClient)
  const remoteResendSignatureEmail = new RemoteResendSignatureEmail(
    URL,
    axiosHttpClient
  )

  const remoteCancelContract = new RemoteCancelContract(
    `${URL}/contracts`,
    axiosHttpClient
  )

  document.title = 'Recebível Chipado - Detalhes do Contrato'

  return (
    <ContractDetails
      remoteGetContract={remoteGetContract}
      remoteResendSignatureEmail={(signatureId: string) =>
        remoteResendSignatureEmail.execute(signatureId)
      }
      remoteCancelContract={remoteCancelContract}
    />
  )
}
